import {
  api,
} from "@/lib/api";


// ACTA_AGENT_API_V5

export const plan = (
  payload
) =>
  api
    .post(
      "/agent/plan",
      payload
    )
    .then(
      (response) =>
        response.data
    );

export const resolveMachine = (
  query
) =>
  api
    .post(
      "/agent/resolve/machine",
      { query }
    )
    .then(
      (response) =>
        response.data
    );

export const resolveIntervention = (
  query
) =>
  api
    .post(
      "/agent/resolve/intervention",
      { query }
    )
    .then(
      (response) =>
        response.data
    );

export const resolveTechnician = (
  query
) =>
  api
    .post(
      "/agent/resolve/technician",
      { query }
    )
    .then(
      (response) =>
        response.data
    );

export const execute = ({
  actionId,
  input = {},
  confirmed = false,
}) =>
  api
    .post(
      "/agent/execute",
      {
        actionId,
        input,
        confirmed,
      }
    )
    .then(
      (response) =>
        response.data
    );
